import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@rdlabo/shared/src/environments/environment';
import { tap } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import type { INotifications, IUserStatus } from '@rdlabo/odss-mobile-hono/src/api/auth/api';
import type { IAe } from '@rdlabo/odss-mobile-hono/src/api/resources/ae/api';
import { KitOverlayController } from '@rdlabo/ionic-angular-kit';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  readonly #http = inject(HttpClient);
  readonly #overlay = inject(KitOverlayController);

  constructor() {}

  getStatus(): Promise<IUserStatus> {
    return firstValueFrom(this.#http.get<IUserStatus>(environment.api() + 'auth/status'));
  }

  updateProfile(profile: IAe): Promise<void> {
    return firstValueFrom(
      this.#http.post<void>(environment.api() + 'auth/profile', profile).pipe(
        tap(async () => {
          await this.#overlay.presentToast({
            message: '保存しました',
          });
        }),
      ),
    );
  }

  getNotifications(): Promise<INotifications> {
    return firstValueFrom(this.#http.get<INotifications>(environment.api() + 'auth/notifications'));
  }

  updateNotifications(notifications: INotifications): Promise<void> {
    return firstValueFrom(
      this.#http.post<void>(environment.api() + 'auth/notifications', notifications).pipe(
        tap(async () => {
          await this.#overlay.presentToast({
            message: '保存しました',
          });
        }),
      ),
    );
  }
}
